export const isStripeOnboardingPending = (status) => {
  const normalized = (status || "").toString().trim().toLowerCase();
  return [
    "pending",
    "incomplete",
    "requires_action",
    "action_required",
    "not_started",
  ].includes(normalized);
};

export const isStripeAccountInactive = (status) => {
  const normalized = (status || "").toString().trim().toLowerCase();
  return normalized === "inactive";
};

export const requiresStripeOnboarding = (onboardingStatus, accountStatus) =>
  isStripeOnboardingPending(onboardingStatus) ||
  isStripeAccountInactive(accountStatus);
